import { render, staticRenderFns } from "./matchtitle.vue?vue&type=template&id=65453df0&scoped=true&"
import script from "./matchtitle.vue?vue&type=script&lang=js&"
export * from "./matchtitle.vue?vue&type=script&lang=js&"
import style0 from "./matchtitle.vue?vue&type=style&index=0&id=65453df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65453df0",
  null
  
)

export default component.exports